import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../components/alert-dialog/alert-dialog.component';
import { AlertType } from '../utils/types';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private dialog = inject(MatDialog);

  openAlertDialog({ message, title = '', primaryButtonText, secondaryButtonText = 'Ok' }: AlertType): void {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: { title, message, primaryButtonText, secondaryButtonText },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // handle primary action
      } else {
        // handle secondary action
      }
    });
  }

  showAlert({ message, title, primaryButtonText, secondaryButtonText }: AlertType): void {
    this.openAlertDialog({ message, title, primaryButtonText, secondaryButtonText });
  }
}
